export default __webpack_public_path__ + "static/media/grinning.9fe30728.svg";